import { t } from "i18next";
import React from "react";
import { Container } from "react-bootstrap";
import InnerBanner from "./InnerBanner";

export default class SamplePage extends React.Component {

    componentDidMount() {
        const elementsToHide = document.querySelectorAll(
            ".partner-sec, .chatIcon, .applynow-sec, .chat-sec, .payonline-sec, .custom-icon"
        );
        elementsToHide.forEach((el) => {
            el.style.display = "none";
        });
    }

    render() {
        return (
            <>
                <InnerBanner
                    title={t("Pre-approved Top-up T&C")}
                    heading={t("Pre-approved Top-up T&C")}
                    imgsrc="../img/career-banners.png"
                />

                <section className="section entry-container">
                    <Container>
                        <div className="entry-content-sample-page">
                            <p>
                                <strong>
                                    *
                                    {t(
                                        "By submitting the OTP, I agree to the following Terms & Conditions:")}
                                </strong>
                            </p>
                            <ol>
                                <li>
                                    The Top-Up Loan shall be subject to levy of processing fees of 1% on disbursed loan amount, applicable interest rate (per annum), statutory levies, applicable taxes, and such other charges as may be prescribed under the Company’s prevailing schedule of charges and policies shall be applicable at the time of submission and processing of the Top-Up Loan application.
                                </li>

                                <li>
                                    The Top-Up Loan facility shall be available only where all Post Disbursement Documents (PDDs) in relation to the borrower’s existing loan exposure with the Company have been duly submitted and are found to be complete and satisfactory. In the event any PDD remains pending, deficient, or non-compliant, the Company reserves the right to withhold, suspend, or decline the Top-Up Loan facility at its discretion.
                                </li>

                                <li>
                                    The borrower authorizes the Company to obtain and share credit information relating to the borrower with credit bureaus, financial institutions, and other relevant entities for the purpose of processing and monitoring the Top-Up Loan facility.
                                </li>

                                <li>
                                    The Top-Up Loan offer is extended upfront based on the customer’s preliminary eligibility assessment derived from the Company’s internal evaluation of the customer’s existing loan relationship, repayment track record, and other data available with the Company. Such offer is indicative in nature and does not constitute a binding commitment by the Company. The Top-Up Loan shall remain subject to verification of information, submission of required documents (if applicable), internal credit evaluation, and final approval by the Company in accordance with its internal policies.
                                </li>

                                <li>
                                    The Company reserves the right to reject, cancel, withdraw, or discontinue the Top-Up Loan application or approval at any stage of the process in the event of any misrepresentation, discrepancy, incorrect information, non-disclosure of material facts, or non-compliance identified during verification, credit appraisal, documentation review, or at any subsequent stage.
                                </li>

                                <li>
                                    The Top-Up Loan is offered based on the borrower’s existing loan relationship with the Company and shall be subject to continued compliance with the Company’s eligibility criteria, satisfactory repayment track record, credit evaluation norms, and internal risk and credit policies, as may be amended from time to time.
                                </li>

                                <li>
                                    Any pre-approved or Auto Top-Up Loan offer shall be valid only for a limited period and may be modified, withdrawn, or cancelled by the Company at any time prior to disbursement, without assigning any reason.
                                </li>

                                <li>
                                    The Company reserves the right to revise or modify the eligibility criteria, loan amount, pricing, charges, or any other terms and conditions of the Top-Up Loan facility in accordance with its internal policies and applicable regulatory guidelines.
                                </li>

                                <li>
                                    The Company may require the borrower to submit additional documents, information, or clarifications at any stage of the Top-Up Loan process. Failure to provide such information may result in rejection or cancellation of the application.
                                </li>

                                <li>
                                    The Top-Up Loan shall be governed by the Company’s standard loan agreement, applicable product policies, Fair Practices Code, and regulatory guidelines issued by the Reserve Bank of India (RBI) / National Housing Bank (NHB) or any other statutory, regulatory, or governmental authority, as may be amended from time to time, including applicable requirements relating to the creation, modification, perfection, and registration of security interests with relevant authorities.
                                </li>

                                <li>
                                    Acceptance of the Top-Up Loan offer through digital means, including but not limited to mobile application, website, OTP authentication, or electronic communication, shall constitute valid and legally binding acceptance of the applicable terms and conditions.
                                </li>

                                <li>
                                    The Borrower confirms that there has been no change in the Know Your Customer (KYC) details and documents previously submitted to the Company. In the event of any change, the Borrower undertakes to provide updated or fresh KYC documents or details to the Company.
                                </li>

                                <li>
                                    In case of any queries, concerns, or grievances relating to the Top-Up Loan facility or the services provided by the Company, the borrower may approach the Company’s Grievance Redressal Mechanism in accordance with the procedures outlined in the Grievance Redressal Policy available on the Company’s website and branch offices.
                                </li>

                                <li>
                                    All matters arising out of or in connection with the Top-Up Loan facility, shall be subject to the exclusive jurisdiction of the competent courts and tribunals located in Delhi.
                                </li>
                            </ol>
                        </div>
                    </Container>
                </section>
            </>
        );
    }
}
